import React from 'react'

const Jva_arrL = () => {
    return (
        <div className='container'>
            
      
      <h1 class="h1">Java ArrayList</h1>
     
      <p>Java <strong>ArrayList</strong> class uses a <em>dynamic array </em> for storing the
            elements. It is like an array, but there is <em>no size limit</em>. We can add or remove elements anytime.
            So, it is much more flexible than the traditional array. It is found in the <em>java.util</em> package. It
            is like the Vector in C++.</p>
      <p>The ArrayList in Java can have the duplicate elements also. It implements the List interface so we can use all
            the methods of List interface here. The ArrayList maintains the insertion order internally.</p>
      <p>It inherits the AbstractList class and implements List interface.
      </p>
      <p>The important points about Java ArrayList class are:</p>
      <ul class="points">
            <li>Java ArrayList class can contain duplicate elements.</li>
            <li>Java ArrayList class maintains insertion order.</li>
            <li>Java ArrayList class is non synchronized.</li>
            <li>Java ArrayList allows random access because array works at the index basis.</li>
            <li>In ArrayList, manipulation is little bit slower than the LinkedList in Java because a lot of shifting
                  needs to occur if any element is removed from the array list.</li>
      </ul>
      <h3 class="h3">Hierarchy of ArrayList class</h3>
      <p>As shown in the above diagram, Java ArrayList class extends AbstractList class which implements List interface.
            The List interface extends the Collection and
            Iterable interfaces in hierarchical order.</p>
      <h3 class="h3">ArrayList class declaration</h3>
      <p>Let's see the declaration for java.util.ArrayList class.</p>
      <div class="containers">
            <div class="container">
                 
                
                        <div class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;ArrayList&lt;E&gt;&nbsp;</span> <br /><span
                                          class="keywords">extends</span><span>&nbsp;AbstractList&lt;E&gt;&nbsp;</span> <br /><span
                                          class="keywords">implements</span><span>&nbsp;List&lt;E&gt;,&nbsp;RandomAccess,&nbsp;Cloneable,&nbsp;Serializable&nbsp;&nbsp;</span></span>
                        </div>
                 
            
            </div>
      </div>
      <h3 class="h3">Constructors of ArrayList</h3>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>Constructor</th>
                        <th>Description</th>
                  </tr>
                  <tr>
                        <td>ArrayList()</td>
                        <td>It is used to build an empty array list.</td>
                  </tr>
                  <tr>
                        <td>ArrayList(Collection&lt;? extends E&gt; c)</td>
                        <td>It is used to build an array list that is initialized with the elements of the collection c.
                        </td>
                  </tr>
                  <tr>
                        <td>ArrayList(int capacity)</td>
                        <td>It is used to build an array list that has the specified initial capacity. </td>
                  </tr>
            </tbody>
      </table>
      <hr/>
      <br/>
      <h3 class="h3">Methods of ArrayList</h3>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>Method</th>
                        <th>Description</th>
                  </tr>
                  <tr>
                        <td>void add (int index, E element)</td>
                        <td>It is used to insert the specified element at the specified position in a list.</td>
                  </tr>
                  <tr>
                        <td>boolean add(E e)</td>
                        <td>It is used to append the specified element at the end of a list.</td>
                  </tr>
                  <tr>
                        <td>boolean addAll(Collection&lt;? extends E&gt; c)
                        </td>
                        <td>It is used to append all of the elements in the specified collection to the end of this
                              list, in the order that they are returned by the specified collection's iterator.</td>
                  </tr>
                  <tr>
                        <td>boolean addAll(int index, Collection&lt;? extends
                              E&gt; c)</td>
                        <td>It is used to append all the elements in the specified collection, starting at the specified
                              position of the list.</td>
                  </tr>
                  <tr>
                        <td>void clear()</td>
                        <td>It is used to remove all of the elements from this list.</td>
                  </tr>
                  <tr>
                        <td>void ensureCapacity(int requiredCapacity)</td>
                        <td>It is used to enhance the capacity of an ArrayList instance.</td>
                  </tr>
                  <tr>
                        <td>E get(int index)</td>
                        <td>It is used to fetch the element from the particular position of the list.</td>
                  </tr>
                  <tr>
                        <td>boolean isEmpty()</td>
                        <td>It returns true if the list is empty, otherwise false.</td>
                  </tr>
                  <tr>
                        <td>Iterator()</td>
                        <td></td>
                  </tr>
                  <tr>
                        <td>listIterator()</td>
                        <td></td>
                  </tr>
                  <tr>
                        <td>int lastIndexOf(Object o)</td>
                        <td>It is used to return the index in this list of the last occurrence of the specified element,
                              or -1 if the list does not contain this element.</td>
                  </tr>
                  <tr>
                        <td>Object[] toArray()</td>
                        <td>It is used to return an array containing all of the elements in this list in the correct
                              order.</td>
                  </tr>
                  <tr>
                        <td>&lt;T&gt; T[] toArray(T[] a)</td>
                        <td>It is used to return an array containing all of the elements in this list in the correct
                              order.</td>
                  </tr>


                  <tr>
                        <td>Object clone()</td>
                        <td>It is used to return a shallow copy of an ArrayList.</td>
                  </tr>
                  <tr>
                        <td>boolean contains(Object o)</td>
                        <td>It returns true if the list contains the specified element</td>
                  </tr>
                  <tr>
                        <td>int indexOf(Object o)</td>
                        <td>It is used to return the index in this list of the first occurrence of the specified
                              element, or -1 if the List does not contain this element.</td>
                  </tr>
                  <tr>
                        <td>E remove(int index)</td>
                        <td>It is used to remove the element present at the specified position in the list.</td>
                  </tr>
                  <tr>
                        <td>boolean remove(Object o)</td>
                        <td>It is used to remove the first occurrence of the specified element.</td>
                  </tr>
                  <tr>
                        <td>boolean removeAll(Collection&lt;?&gt; c)</td>
                        <td>It is used to remove all the elements from the list.</td>
                  </tr>
                  <tr>
                        <td>boolean removeIf(Predicate&lt;? super E&gt; filter)</td>
                        <td>It is used to remove all the elements from the list that satisfies the given predicate.</td>
                  </tr>
                  <tr>
                        <td>protected void removeRange(int fromIndex,
                              int toIndex)</td>
                        <td>It is used to remove all the elements lies within the given range.</td>
                  </tr>
                  <tr>
                        <td>void replaceAll(UnaryOperator&lt;E&gt; operator)</td>
                        <td>It is used to replace all the elements from the list with the specified element.</td>
                  </tr>
                  <tr>
                        <td>void retainAll(Collection&lt;?&gt; c)</td>
                        <td>It is used to retain all the elements in the list that are present in the specified
                              collection.</td>
                  </tr>
                  <tr>
                        <td>E set(int index, E element)</td>
                        <td>It is used to replace the specified element in the list, present at the specified position.
                        </td>
                  </tr>
                  <tr>
                        <td>void sort(Comparator&lt;? super E&gt; c)</td>
                        <td>It is used to sort the elements of the list on the basis of specified comparator.</td>
                  </tr>
                  <tr>
                        <td>Spliterator&lt;E&gt; spliterator()</td>
                        <td>It is used to create spliterator over the elements in a list.</td>
                  </tr>
                  <tr>
                        <td>List&lt;E&gt; subList(int fromIndex, int toIndex)</td>
                        <td>It is used to fetch all the elements lies within the given range.</td>
                  </tr>
                  <tr>
                        <td>int size()</td>
                        <td>It is used to return the number of elements present in the list.</td>
                  </tr>

                  <tr>
                        <td>void trimToSize()</td>
                        <td>It is used to trim the capacity of this ArrayList instance to be the list's current size.
                        </td>
                  </tr>
            </tbody>
      </table>

      <h3 class="h2">Java Non-generic Vs. Generic Collection</h3>
      <p>Java collection framework was non-generic before JDK 1.5. Since 1.5, it is generic.</p>
      <p>Java new generic collection allows you to have only one type of object in a collection. Now it is type safe so
            typecasting is not required at runtime.</p>
      <p>Let's see the old non-generic example of creating java collection.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span>ArrayList&nbsp;list=</span><span
                                          class="keywords">new</span><span>&nbsp;ArrayList();</span><span
                                          class="comment">//creating&nbsp;old&nbsp;non-generic&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                  </ol>
                  
            </div>
      </div>

      <p>Let's see the new generic example of creating java collection.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span>ArrayList&lt;String&gt;&nbsp;list=</span><span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();</span><span
                                          class="comment">//creating&nbsp;new&nbsp;generic&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                  </ol>
                  
            </div>
      </div>
      <p>In a generic collection, we specify the type in angular braces. Now ArrayList is forced to have the only
            specified type of objects in it. If you try to add another type of object, it gives <i>compile time
                  error</i>.</p>

      


     
      <h3 class="h3">Java ArrayList Example</h3>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;ArrayListExample1&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;list=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();</span><span
                                          class="comment">//Creating&nbsp;arraylist&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Mango"</span><span>);</span><span
                                          class="comment">//Adding&nbsp;object&nbsp;in&nbsp;arraylist&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Apple"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Banana"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Grapes"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Printing&nbsp;the&nbsp;arraylist&nbsp;object&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(list);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt"><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
     
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>[Mango, Apple, Banana, Grapes]
      </pre>
      </div>

      <h3 class="h3">Iterating ArrayList using Iterator</h3>
      <p>Let's see an example to traverse ArrayList elements using the Iterator interface.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;ArrayListExample2&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;list=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();</span><span
                                          class="comment">//Creating&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Mango"</span><span>);</span><span
                                          class="comment">//Adding&nbsp;object&nbsp;in&nbsp;arraylist&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Apple"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Banana"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Grapes"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list&nbsp;through&nbsp;Iterator</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;Iterator&nbsp;itr=list.iterator();<span
                                          class="comment">//getting&nbsp;the&nbsp;Iterator</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="keywords">while</span><span>(itr.hasNext())&#123;</span><span
                                          class="comment">//check&nbsp;if&nbsp;iterator&nbsp;has&nbsp;the&nbsp;elements</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;System.out.println(itr.next());<span
                                          class="comment">//printing&nbsp;the&nbsp;element&nbsp;and&nbsp;move&nbsp;to&nbsp;next</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>

     
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Mango <br/>
      Apple <br/>
      Banana <br/>
      Grapes <br/>
      </pre>
      </div>

      <h3 class="h3">Iterating ArrayList using For-each loop</h3>
      <p>Let's see an example to traverse the ArrayList elements using the for-each loop</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;ArrayListExample3&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;list=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();</span><span
                                          class="comment">//Creating&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Mango"</span><span>);</span><span
                                          class="comment">//Adding&nbsp;object&nbsp;in&nbsp;arraylist&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Apple"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Banana"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;list.add(<span
                                          class="string">"Grapes"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list&nbsp;through&nbsp;for-each&nbsp;loop</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(String&nbsp;fruit:list)&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(fruit);&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
     
      <div class="output">
            <pre>Mango <br/>
      Apple <br/>
      Banana <br/>
      Grapes <br/>
      </pre>
      </div>
      <h3 class="h3">Get and Set ArrayList</h3>
      <p>The <em>get() method</em> returns the element at the specified index, whereas the <em>set() method</em> changes
            the element.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;ArrayListExample4&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Mango"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Apple"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Banana"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Grapes"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//accessing&nbsp;the&nbsp;element&nbsp;&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Returning&nbsp;element:&nbsp;"</span><span>+al.get(</span><span
                                          class="number">1</span><span>));</span>  <br /> <span
                                          class="comment">//it&nbsp;will&nbsp;return&nbsp;the&nbsp;2nd&nbsp;element,&nbsp;because&nbsp;index&nbsp;starts&nbsp;from&nbsp;0</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//changing&nbsp;the&nbsp;element</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;al.set(<span class="number">1</span><span>,</span><span
                                          class="string">"Dates"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(String&nbsp;fruit:al)&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(fruit);&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Returning element: Apple <br/>
      Mango <br/>
      Dates <br/>
      Banana <br/>
      Grapes <br/>
      </pre>
      </div>

      <h3 class="h3">How to Sort ArrayList</h3>
      <p>The <em>java.util</em> package provides a utility class <strong>Collections</strong> which has the static
            method sort(). Using the <strong>Collections.sort()</strong> method, we can easily sort the ArrayList.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keywords">class</span><span>&nbsp;SortArrayList&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;a&nbsp;list&nbsp;of&nbsp;fruits</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;List&lt;String&gt;&nbsp;list1=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;list1.add(<span
                                          class="string">"Mango"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;list1.add(<span
                                          class="string">"Apple"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;list1.add(<span
                                          class="string">"Banana"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;list1.add(<span
                                          class="string">"Grapes"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="comment">//Sorting&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;Collections.sort(list1);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list&nbsp;through&nbsp;the&nbsp;for-each&nbsp;loop</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(String&nbsp;fruit:list1)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(fruit);&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;System.out.println(<span
                                          class="string">"Sorting&nbsp;numbers..."</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;a&nbsp;list&nbsp;of&nbsp;numbers</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;List&lt;Integer&gt;&nbsp;list2=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;Integer&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;list2.add(<span
                                          class="number">21</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;list2.add(<span
                                          class="number">11</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;list2.add(<span
                                          class="number">51</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;list2.add(<span
                                          class="number">1</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//Sorting&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;Collections.sort(list2);&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list&nbsp;through&nbsp;the&nbsp;for-each&nbsp;loop</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(Integer&nbsp;number:list2)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(number);&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Apple <br/>
      Banana <br/>
      Grapes <br/>
      Mango <br/>
      Sorting numbers... <br/>
      1 <br/>
      11 <br/>
      21 <br/>
      51 <br/>
      </pre>
      </div>

      <hr/>

      <h3 class="h3">Ways to iterate the elements of the collection in Java</h3>
      <p>There are various ways to traverse the collection elements:</p>
      <ol class="points">
            <li>By Iterator interface.</li>
            <li>By for-each loop.</li>
            <li>By ListIterator interface.</li>
            <li>By for loop.</li>
            <li>By forEach() method.</li>
            <li>By forEachRemaining() method.</li>
      </ol>
      

      <h3 class="h3">Iterating Collection through remaining ways</h3>
      <p>Let's see an example to traverse the ArrayList elements through other ways</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keywords">class</span><span>&nbsp;ArrayList4&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;list=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();</span><span
                                          class="comment">//Creating&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Ravi"</span><span>);</span><span
                                          class="comment">//Adding&nbsp;object&nbsp;in&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Traversing&nbsp;list&nbsp;through&nbsp;List&nbsp;Iterator:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Here,&nbsp;element&nbsp;iterates&nbsp;in&nbsp;reverse&nbsp;order</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ListIterator&lt;String&gt;&nbsp;list1=list.listIterator(list.size());&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">while</span><span>(list1.hasPrevious())&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;String&nbsp;str=list1.previous();&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(str);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Traversing&nbsp;list&nbsp;through&nbsp;for&nbsp;loop:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(</span><span
                                          class="keywords">int</span><span>&nbsp;i=</span><span
                                          class="number">0</span><span>;i&lt;list.size();i++)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(list.get(i));&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Traversing&nbsp;list&nbsp;through&nbsp;forEach()&nbsp;method:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//The&nbsp;forEach()&nbsp;method&nbsp;is&nbsp;a&nbsp;new&nbsp;feature,&nbsp;introduced&nbsp;in&nbsp;Java&nbsp;8.</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;list.forEach(a-&gt;&#123;&nbsp;<span
                                          class="comment">//Here,&nbsp;we&nbsp;are&nbsp;using&nbsp;lambda&nbsp;expression</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(a);&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Traversing&nbsp;list&nbsp;through&nbsp;forEachRemaining()&nbsp;method:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Iterator&lt;String&gt;&nbsp;itr=list.iterator();&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;itr.forEachRemaining(a-&gt;&nbsp;<span
                                          class="comment">//Here,&nbsp;we&nbsp;are&nbsp;using&nbsp;lambda&nbsp;expression</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(a);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;);&nbsp;&nbsp;</span>
                        </li>
                        <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Traversing list through List Iterator: <br/>
      Ajay <br/>
      Ravi <br/>
      Vijay <br/>
      Ravi <br/>
      Traversing list through for loop: <br/>
      Ravi <br/>
      Vijay <br/>
      Ravi <br/>
      Ajay <br/>
      Traversing list through forEach() method: <br/>
      Ravi <br/>
      Vijay <br/>
      Ravi <br/>
      Ajay <br/>
      Traversing list through forEachRemaining() method: <br/>
      Ravi <br/>
      Vijay <br/>
      Ravi <br/>
      Ajay <br/>
      
      </pre>
      </div>
      <hr/>

      <h3 class="h3">User-defined class objects in Java ArrayList</h3>
      <p>Let's see an example where we are storing Student class object in an array list.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">class</span><span>&nbsp;Student&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">int</span><span>&nbsp;rollno;&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;String&nbsp;name;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">int</span><span>&nbsp;age;&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;Student(<span
                                          class="keywords">int</span><span>&nbsp;rollno,String&nbsp;name,</span><span
                                          class="keywords">int</span><span>&nbsp;age)&#123;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.rollno=rollno;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.name=name;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.age=age;&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <br/>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;<span
                                          class="keywords">class</span><span>&nbsp;ArrayList5&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;user-defined&nbsp;class&nbsp;objects</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;Student&nbsp;s1=<span
                                          class="keywords">new</span><span>&nbsp;Student(</span><span
                                          class="number">101</span><span>,</span><span
                                          class="string">"Sonoo"</span><span>,</span><span
                                          class="number">23</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;Student&nbsp;s2=<span
                                          class="keywords">new</span><span>&nbsp;Student(</span><span
                                          class="number">102</span><span>,</span><span
                                          class="string">"Ravi"</span><span>,</span><span
                                          class="number">21</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;Student&nbsp;s2=<span
                                          class="keywords">new</span><span>&nbsp;Student(</span><span
                                          class="number">103</span><span>,</span><span
                                          class="string">"Hanumat"</span><span>,</span><span
                                          class="number">25</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="comment">//creating&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;ArrayList&lt;Student&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;Student&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;al.add(s1);<span
                                          class="comment">//adding&nbsp;Student&nbsp;class&nbsp;object</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(s2);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;al.add(s3);&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//Getting&nbsp;Iterator</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;Iterator&nbsp;itr=al.iterator();&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;<span
                                          class="comment">//traversing&nbsp;elements&nbsp;of&nbsp;ArrayList&nbsp;object</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">while</span><span>(itr.hasNext())&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;Student&nbsp;st=(Student)itr.next();&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(st.rollno+<span
                                          class="string">"&nbsp;"</span><span>+st.name+</span><span
                                          class="string">"&nbsp;"</span><span>+st.age);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>

      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>       101 Sonoo 23 <br/>
             102 Ravi 21 <br/>
             103 Hanumat 25 <br/>
      </pre>
      </div>

      <hr/>


      <h3 class="h3">Java ArrayList Serialization and Deserialization Example</h3>
      <p>Let's see an example to serialize an ArrayList object and then deserialize it.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.io.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span
                                          class="keywords">class</span><span>&nbsp;ArrayList6&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;[]&nbsp;args)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">try</span><span>&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Serialization</span><span>&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FileOutputStream&nbsp;fos=<span
                                          class="keywords">new</span><span>&nbsp;FileOutputStream(</span><span
                                          class="string">"file"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ObjectOutputStream&nbsp;oos=<span
                                          class="keywords">new</span><span>&nbsp;ObjectOutputStream(fos);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;oos.writeObject(al);&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fos.close();&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;oos.close();&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Deserialization</span><span>&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FileInputStream&nbsp;fis=<span
                                          class="keywords">new</span><span>&nbsp;FileInputStream(</span><span
                                          class="string">"file"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ObjectInputStream&nbsp;ois=<span
                                          class="keywords">new</span><span>&nbsp;ObjectInputStream(fis);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&nbsp;&nbsp;list=(ArrayList)ois.readObject();&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(list);&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                                          class="keywords">catch</span><span>(Exception&nbsp;e)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(e);&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>       [Ravi, Vijay, Ajay]
      </pre>
      </div>
      <hr/>

      <h3 class="h3">Java ArrayList example to add elements</h3>
      <p>Here, we see different ways to add an element.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;<span
                                          class="keywords">class</span><span>&nbsp;ArrayList7&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Initial&nbsp;list&nbsp;of&nbsp;elements:&nbsp;"</span><span>+al);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;elements&nbsp;to&nbsp;the&nbsp;end&nbsp;of&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;add(E&nbsp;e)&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;an&nbsp;element&nbsp;at&nbsp;the&nbsp;specific&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="number">1</span><span>,&nbsp;</span><span
                                          class="string">"Gaurav"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;add(int&nbsp;index,&nbsp;E&nbsp;element)&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al2=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al2.add(<span
                                          class="string">"Sonoo"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al2.add(<span
                                          class="string">"Hanumat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;second&nbsp;list&nbsp;elements&nbsp;to&nbsp;the&nbsp;first&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.addAll(al2);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;addAll(Collection&lt;?&nbsp;extends&nbsp;E&gt;&nbsp;c)&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al3=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al3.add(<span
                                          class="string">"John"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al3.add(<span
                                          class="string">"Rahul"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;second&nbsp;list&nbsp;elements&nbsp;to&nbsp;the&nbsp;first&nbsp;list&nbsp;at&nbsp;specific&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.addAll(<span
                                          class="number">1</span><span>,&nbsp;al3);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;addAll(int&nbsp;index,&nbsp;Collection&lt;?&nbsp;extends&nbsp;E&gt;&nbsp;c)&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt"><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Initial list of elements: [] <br/>
      After invoking add(E e) method: [Ravi, Vijay, Ajay] <br/>
      After invoking add(int index, E element) method: [Ravi, Gaurav, Vijay, Ajay] <br/>
      After invoking addAll(Collection&lt;? extends E&gt; c) method:  <br/>
      [Ravi, Gaurav, Vijay, Ajay, Sonoo, Hanumat] <br/>
      After invoking addAll(int index, Collection&lt;? extends E&gt; c) method:  <br/>
      [Ravi, John, Rahul, Gaurav, Vijay, Ajay, Sonoo, Hanumat] <br/>
      </pre>
      </div>

      <hr/>

      <h3 class="h3">Java ArrayList example to remove elements</h3>
      <p>Here, we see different ways to remove an element.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;<span
                                          class="keywords">class</span><span>&nbsp;ArrayList8&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;[]&nbsp;args)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Anuj"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Gaurav"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"An&nbsp;initial&nbsp;list&nbsp;of&nbsp;elements:&nbsp;"</span><span>+al);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;specific&nbsp;element&nbsp;from&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.remove(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;remove(object)&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;element&nbsp;on&nbsp;the&nbsp;basis&nbsp;of&nbsp;specific&nbsp;position</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.remove(<span
                                          class="number">0</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;remove(index)&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;another&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al2=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al2.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al2.add(<span
                                          class="string">"Hanumat"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;new&nbsp;elements&nbsp;to&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.addAll(al2);&nbsp;&nbsp;</span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Updated&nbsp;list&nbsp;:&nbsp;"</span><span>+al);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;all&nbsp;the&nbsp;new&nbsp;elements&nbsp;from&nbsp;arraylist</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.removeAll(al2);&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeAll()&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;elements&nbsp;on&nbsp;the&nbsp;basis&nbsp;of&nbsp;specified&nbsp;condition</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.removeIf(str&nbsp;-&gt;&nbsp;str.contains(<span
                                          class="string">"Ajay"</span><span>));&nbsp;&nbsp;&nbsp;</span><span
                                          class="comment">//Here,&nbsp;we&nbsp;are&nbsp;using&nbsp;Lambda&nbsp;expression&nbsp;</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;removeIf()&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Removing&nbsp;all&nbsp;the&nbsp;elements&nbsp;available&nbsp;in&nbsp;the&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.clear();&nbsp;&nbsp;</span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;invoking&nbsp;clear()&nbsp;method:&nbsp;"</span><span>+al);&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        </li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>An initial list of elements: [Ravi, Vijay, Ajay, Anuj, Gaurav] <br/>
      After invoking remove(object) method: [Ravi, Ajay, Anuj, Gaurav] <br/>
      After invoking remove(index) method: [Ajay, Anuj, Gaurav] <br/>
      Updated list : [Ajay, Anuj, Gaurav, Ravi, Hanumat] <br/>
      After invoking removeAll() method: [Ajay, Anuj, Gaurav] <br/>
      After invoking removeIf() method: [Anuj, Gaurav] <br/>
      After invoking clear() method: [] <br/>
      </pre>
      </div>
      <hr/>

      <h3 class="h3">Java ArrayList example of retainAll() method</h3>

      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keywords">class</span><span>&nbsp;ArrayList9&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;<span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;al.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al2=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;al2.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;al2.add(<span
                                          class="string">"Hanumat"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;al.retainAll(al2);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;System.out.println(<span
                                          class="string">"iterating&nbsp;the&nbsp;elements&nbsp;after&nbsp;retaining&nbsp;the&nbsp;elements&nbsp;of&nbsp;al2"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;Iterator&nbsp;itr=al.iterator();&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;<span
                                          class="keywords">while</span><span>(itr.hasNext())&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;System.out.println(itr.next());&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>       iterating the elements after retaining the elements of al2
             Ravi
      </pre>
      </div>

      <h3 class="h3">Java ArrayList example of isEmpty() method</h3>

      <div class="containers">
            <div class="dp-highlighter">
                 
                      
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;<span
                                          class="keywords">class</span><span>&nbsp;ArrayList10&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String&nbsp;[]&nbsp;args)&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123;&nbsp;&nbsp;</span></li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ArrayList&lt;String&gt;&nbsp;al=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Is&nbsp;ArrayList&nbsp;Empty:&nbsp;"</span><span>+al.isEmpty());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ravi"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;al.add(<span
                                          class="string">"Ajay"</span><span>);&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;Insertion"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="">
                              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Is&nbsp;ArrayList&nbsp;Empty:&nbsp;"</span><span>+al.isEmpty());&nbsp;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>Is ArrayList Empty: true <br/>
      After Insertion <br/>
      Is ArrayList Empty: false <br/>
      </pre>
      </div>
      <hr/>

      <h3 class="h3">Java ArrayList Example: Book</h3>
      <p>Let's see an ArrayList example where we are adding books to list and printing all the books.</p>
      <div class="containers">
            <div class="dp-highlighter">
                 
                       
                  <ol start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keywords">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keywords">class</span><span>&nbsp;Book&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span class="keywords">int</span><span>&nbsp;id;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>String&nbsp;name,author,publisher;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span><span
                                          class="keywords">int</span><span>&nbsp;quantity;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;Book(</span><span
                                          class="keywords">int</span><span>&nbsp;id,&nbsp;String&nbsp;name,&nbsp;String&nbsp;author,&nbsp;String&nbsp;publisher,&nbsp;</span><span
                                          class="keywords">int</span><span>&nbsp;quantity)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.id&nbsp;=&nbsp;id;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.name&nbsp;=&nbsp;name;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.author&nbsp;=&nbsp;author;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.publisher&nbsp;=&nbsp;publisher;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">this</span><span>.quantity&nbsp;=&nbsp;quantity;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">class</span><span>&nbsp;ArrayListExample20&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span class="keywords">public</span><span>&nbsp;</span><span
                                          class="keywords">static</span><span>&nbsp;</span><span
                                          class="keywords">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;list&nbsp;of&nbsp;Books</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;List&lt;Book&gt;&nbsp;list=<span
                                          class="keywords">new</span><span>&nbsp;ArrayList&lt;Book&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;Books</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b1=<span
                                          class="keywords">new</span><span>&nbsp;Book(</span><span
                                          class="number">101</span><span>,</span><span
                                          class="string">"Let&nbsp;us&nbsp;C"</span><span>,</span><span
                                          class="string">"Yashwant&nbsp;Kanetkar"</span><span>,</span><span
                                          class="string">"BPB"</span><span>,</span><span
                                          class="number">8</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b2=<span
                                          class="keywords">new</span><span>&nbsp;Book(</span><span
                                          class="number">102</span><span>,</span><span
                                          class="string">"Data&nbsp;Communications&nbsp;and&nbsp;Networking"</span><span>,</span><span
                                          class="string">"Forouzan"</span><span>,</span><span
                                          class="string">"Mc&nbsp;Graw&nbsp;Hill"</span><span>,</span><span
                                          class="number">4</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b3=<span
                                          class="keywords">new</span><span>&nbsp;Book(</span><span
                                          class="number">103</span><span>,</span><span
                                          class="string">"Operating&nbsp;System"</span><span>,</span><span
                                          class="string">"Galvin"</span><span>,</span><span
                                          class="string">"Wiley"</span><span>,</span><span
                                          class="number">6</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;Books&nbsp;to&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;list.add(b1);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;list.add(b2);&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;list.add(b3);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;list</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keywords">for</span><span>(Book&nbsp;b:list)&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(b.id+<span
                                          class="string">"&nbsp;"</span><span>+b.name+</span><span
                                          class="string">"&nbsp;"</span><span>+b.author+</span><span
                                          class="string">"&nbsp;"</span><span>+b.publisher+</span><span
                                          class="string">"&nbsp;"</span><span>+b.quantity);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ol>
                  
            </div>
      </div>
      
      <p><strong>Output:</strong></p>
      <div class="output">
            <pre>101 Let us C Yashwant Kanetkar BPB 8 <br/>
      102 Data Communications and Networking Forouzan Mc Graw Hill 4 <br/>
      103 Operating System Galvin Wiley 6 <br/>
      </pre>
      </div>

      </div>
    )
                        
}
export default Jva_arrL
